const updates = [
  { date: '07-28', title: '「社长大人是禽兽」第128话更新', tag: '韩漫', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-28', title: '「咒术回战」第271话汉化完成', tag: '日漫', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-27', title: '「一人之下」第650话 · 全新篇章开启', tag: '国漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-27', title: '「我独自升级」特别篇番外上线', tag: '韩漫', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-26', title: '「间谍过家家」第102话更新推送', tag: '日漫', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-26', title: '新作上架：「末日乐园」漫画版正式连载', tag: '国漫', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-25', title: '「女神降临」完结篇合集整理上线', tag: '韩漫', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-25', title: '阅读体验优化：新增自动翻页功能', tag: '公告', tagColor: 'bg-foreground-100 text-foreground-700' },
  { date: '07-24', title: '「完美世界」动画联动专题上线', tag: '国漫', tagColor: 'bg-primary-100 text-primary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">更新动态</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            皮皮漫画韩漫、日漫与国漫最新更新资讯与平台公告
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-200 hidden sm:block"></div>

          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={idx} className="relative flex gap-5 pb-6 last:pb-0">
                <div className="hidden sm:flex items-center shrink-0 mt-0.5">
                  <div className="w-[38px] h-[38px] rounded-full bg-background-50 border-2 border-background-200 flex items-center justify-center">
                    <div className="w-2 h-2 rounded-full bg-primary-400"></div>
                  </div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                    <span className="text-sm font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium w-fit whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                    <span className="text-sm text-foreground-800 font-medium">{item.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}